import { cx } from '@linaria/core';
import { useRef, useState } from 'react';
import { configRefs } from '@utils/constants';
import { NoSSR, CSSRefTransition, Throbber } from '@utils/react';
import { tokens, playerContainer, player, PLAYER_ENTER_TRANSITION_DURATION_MS } from './atom.video23.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

function Video23Player(props) {
  const iframeRef = useRef(null);
  const [ready, setReady] = useState(false);
  const url = new URL(`${configRefs.apis.video23.video.dangerouslyAssertSyncValue()}/v.ihtml/player.html?source=embed&token=${props.token}&photo%5fid=${props.photoId}&autoPlay=0&subtitlesOnByDefault=${props.showSubtitlesByDefault ? 1 : 0}`);
  if (props.caption?.title?.value) {
    url.searchParams.set("title", props.caption.title.value);
  } else {
    url.searchParams.set("title", " ");
  }
  if (props.caption?.description?.value) {
    url.searchParams.set("description", props.caption.description.value);
  } else {
    url.searchParams.set("description", " ");
  }
  return /*#__PURE__*/jsxs("span", {
    className: playerContainer,
    style: tokens.aspectRatio.__override(props.aspectRatio),
    children: [/*#__PURE__*/jsx(NoSSR, {
      children: /*#__PURE__*/jsx("iframe", {
        ref: iframeRef,
        title: props.title,
        className: cx(player, ready && "ready"),
        src: url.toString(),
        frameBorder: "0",
        scrolling: "no",
        allow: "autoplay; fullscreen",
        onLoad: () => setReady(true)
      }, "iframe")
    }), /*#__PURE__*/jsx(CSSRefTransition, {
      in: !ready,
      timeout: {
        exit: PLAYER_ENTER_TRANSITION_DURATION_MS
      },
      mountOnEnter: true,
      unmountOnExit: true,
      children: ref => /*#__PURE__*/jsx(Throbber, {
        ref: ref
      })
    })]
  });
}

export { Video23Player };
//# sourceMappingURL=atom.video23.js.map
